import React, { useState } from 'react';
import { useTheme } from '@mui/material';
import { useIntl } from 'react-intl';
import { Pie } from '@visx/shape';
import { Group } from '@visx/group';
import { Text } from '@visx/text';

const DonutChart = function DonutChart({
  total, //total for percentage value
  dataToShow = null,
  text = null,
  width, //svg width
  height, //svg height
  themeMode = 'light',
}) {
  const intl = useIntl();
  const theme = useTheme();

  const [isOver, setIsOver] = useState(null);
  const radius = Math.min(width, height) / 2;

  return (
    <svg width={width} height={height} style={{ flexShrink: 0 }}>
      <Group top={height / 2} left={width / 2}>
        <Pie
          data={dataToShow}
          pieValue={(data) => data.value}
          outerRadius={radius}
          innerRadius={({ data }) => {
            const size = isOver && isOver.id === data.id ? 50 : 40;
            return radius - size;
          }}
          cornerRadius={4}
          padAngle={
            dataToShow?.filter(({ value }) => value !== 0).length > 1 ? 0.01 : 0
          }
        >
          {(pie) =>
            pie.arcs.map((arc, index) => {
              const [centroidX, centroidY] = pie.path.centroid(arc);

              return (
                arc.data.value && (
                  <g
                    key={arc.data.id}
                    onMouseEnter={() => setIsOver({ ...arc.data, index })}
                    onMouseLeave={() => setIsOver(null)}
                  >
                    <path d={pie.path(arc)} fill={arc.data?.color[themeMode]} />

                    <Text
                      fill={theme.palette.greys.dark}
                      fontSize=".6vw"
                      fontFamily="Roboto"
                      pointerEvents="none"
                      textAnchor="middle"
                      x={centroidX}
                      y={centroidY + 5}
                    >
                      {
                        //when value is too small label is null
                        Math.round((arc.data.value / total) * 100) < 3
                          ? null
                          : `${Math.round((arc.data.value / total) * 100)}%`
                      }
                    </Text>
                  </g>
                )
              );
            })
          }
        </Pie>
        {isOver ? (
          <>
            <Text
              fill={isOver?.color[themeMode]}
              textAnchor="middle"
              fontFamily="Roboto"
              fontSize="1vw"
              dy={-15}
            >
              {isOver?.value}
            </Text>
            <Text
              fill={theme.palette.greys.secondary}
              textAnchor="middle"
              fontFamily="Roboto"
              fontSize=".9vw"
              dy={10}
            >
              {isOver?.id}
            </Text>
          </>
        ) : (
          <Text
            fill={theme.palette.greys.secondary}
            textAnchor="middle"
            fontFamily="Roboto"
            fontSize=".9vw"
            dy={5}
          >
            {!dataToShow?.every(({ value }) => !value)
              ? text
              : intl.messages.CHART_UNAVAILABLE}
          </Text>
        )}
      </Group>
    </svg>
  );
};

export default DonutChart;
